import React from 'react';
import { any, async, fromJSX, StandardLocalWidget } from "widgets-for-react";
import { UpdatePaymentLayout } from './updatePaymentLayout'
import { SubscriptionState, subscriptionUpdaters } from 'subscription/subscriptionState';

export const updatePaymentWidget = (isLoggedIn: boolean): StandardLocalWidget<SubscriptionState> => currentState => any([
        async(currentState.startSubscriptionUpdatePaymentMethod).map(subscriptionUpdaters.onAsyncStartSubscriptionUpdatePaymentMethodSession),
        fromJSX((setState) => {
            return <UpdatePaymentLayout isLoggedIn={isLoggedIn} setState={setState}/>
        })]
)
